<div class="c__body">
  @if (!isLoading) {
    <div class="c__headline">
      @if (recipeContent?.user) {
        <sd-recipe-user
          [user]="recipeContent?.user"
          [isSmall]="true"
          [showRecipeByLabel]="false"
        />
      }
      @if (recipeContent?.timeLabel) {
        <div class="c__timer">
          <sd-icon name="icon-program-duration" [brand]="brand" />
          <span class="c__time-label is-bold">
            {{ recipeContent?.timeLabel }}
          </span>
        </div>
      }
    </div>
  }
  @if (!isLoading) {
    <div class="c__infos"
      >
      <sd-title [titleLevel]="titleLevel" customClass="brand--h4">
        {{recipeContent?.title}}
      </sd-title>
      @if (ratingData) {
        <sd-rating
          [brand]="brand"
          [ratings]="ratingData"
          [readonly]="true"
          [maxStar]="maxStar"
          [showAverageRatingsLabel]="false"
          [wrapReviewsOnMobile]="true"
        />
      }
    </div>
  }

  @if (isLoading) {
    <sd-skeleton
      [appearance]="skeletonAppearanceEnum.heading"
      [sizeChangeMobile]="false"
      [count]="2"
    />
  }
</div>
@if (recipeContent?.media?.url || recipeContent?.media?.urlTwicPic) {
  <div class="c__media-wrapper">
    <sd-banner
      [isComponentLoading]="isLoading"
      class="c__media"
      [media]="recipeContent?.media"
      [videoTitle]="recipeContent?.title"
      [mediaTitle]="recipeContent?.title"
      [imgRatio]="imageRatio.r4_3"
      [twicPicsAutoSize]="twicPicsAutoSize"
    />
    @if (!isLoading) {
      <div class="c__indications-wrapper">
        @for (tag of recipeContent?.tags; track tag) {
          <sd-tag [tagData]="tag" />
        }
      </div>
    }
    @if (recipeContent?.deviceIcon && !isLoading) {
      <sd-icon
        [size]="iconSize.xl"
        [brand]="brand"
        class="c__device-icon"
        [name]="recipeContent?.deviceIcon"
       />
    }
  </div>
}

@if (recipeContent?.link) {
  <sd-link [link]="recipeContent?.link" (clicked)="onRecipeClick()" customClass="is-full-area">
    <span class="is-visually-hidden">
      {{recipeContent?.title}}
    </span>
  </sd-link>
}
